import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
        list: [],
		pager: {},
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
    },
	actions: {
        // 获取微信客户列表
		async getCustomerList({ commit }: any, params: any) {
			const res:any = await fetch({
                url: '/client/custom',
                params
			})
			res.docs.forEach((item:any) => {
				item.subscribe_time = new Date(parseInt(item.subscribe_time) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ')
			})
            commit('setState',{key:'list',data: res.docs})
            commit('setState',{key:'pager',data: {limit: res.limit,total: res.total}})
		},
		// 绑定手机号码
		async bindPhone({ commit }: any, params: any) {
			return await fetch({
				url: `/client/custom/bindPhone/${params.id}`,
				method: 'put',
				data: {...params.data}
			})
		},
		// 拉黑用户
		async disCustom({ commit }: any, {id, reason}){
			return await fetch({
				url: `/client/disCostom/${id}/${reason}`,
			})
		},
		// 移除拉黑
		async removeDisCustom({}, id){
			return await fetch({
				url: `/client/removeDisCostom/${id}`,
			})
		}
	}
}